import { Button, Dropdown, Tab, Table, Tabs } from "react-bootstrap";
import { useEffect, useMemo, useState } from "react";
import "./invertoryorderlist.scss";
import { ReactSVG } from "react-svg";
import Select from "react-select";
import threedotvertical from "../../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../../assets/images/delete-icon.svg";
import circlecheckicon from "../../../assets/images/circle-check-icon.svg";
import exporticon from "../../../assets/images/export-icon.svg";
import printicon from "../../../assets/images/print-icon.svg";
import refreshicon from "../../../assets/images/refresh-icon.svg";
import DatePicker from "react-date-picker";
import { toggleClass } from "../../../utils/commonUtils";
import useInventoryOrder from "../../../Hooks/useInventoryOrder";
import useVendors from "../../../Hooks/useVendors";
import useMckesson from "../../../Hooks/useMckesson";
import Loading from "../../../components/LoadingPage/Loading";
import { Vendor } from "../../../redux/vendor/vendorSlice";
import { DropDownValues } from "../../../utils/types";
import moment from "moment";
import { FormikHelpers, useFormik } from "formik";
import { selectCurrentUserId } from "../../../redux/auth/authSlice";
import { useAppSelector } from "../../../redux/hooks";
import React from "react";
import { DeleteConfModel } from "../../../components/DeleteConfModel/deleteConfModel";
import { useModulePermissions, PermissionModule, PermissionIdentifier } from "../../../utils/permissionUtils";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import TelerikReporting from "../../../components/TelerikReporting/TelerikReporting";
import { ApprovalItems } from "../InventoryOrderDetail/ApprovalItems";

const InventoryOrderList = () => {
  const [invOrdList, setInvOrdList] = useState([]);
  const [orderStatusOptions, setOrderStatusOptions] = useState<any>([]);
  const [selectedInvOrd, setSelectedInvOrd] = useState<any>([]);
  const [selectedVender, setSelectedVender] = useState<string>("");
  const {
    InvOrderListAPI,
    InvOrderListLoading,
    InvOrdersLoading,
    InvOrderCreateAPI,
    invOrderCreateLoading,
    orderStatusMasterAPI,
    orderStatusMasterLoading,
    deleteInventoryPurchaseOrderAPI,
    invPurchaseOrderDeleteLoading,
    purchaseOrderCreateAPI,
    purchaseOrderCreateLoading,
    getPurchaseOrderAPI,
    getPurchaseOrderLoading,
    completeInventoryOrderItemAPI,
    invOrderItemMarkCompleteLoading,
    InvOrderByIdAPI,
    InvOrderByIdLoading,
    getOrderItemExportAPI,
    getOrderItemsExportLoading,
    deleteInventoryOrderAPI,
    invOrderDeleteLoading,
    completeInventoryOrderAPI,
    invOrderMarkCompleteLoading,
    transmitPurchaseOrderAPI,
    purchaseOrderTransmitLoading,
  } = useInventoryOrder();
  const [showModal, setShowModal] = useState(false);
  const [showItemDeleteModal, setShowItemDeleteModal] = useState(false);
  const { getVendorsAPI, getVendorsLoading } = useVendors();
  const { getMckessonShippingLocationsAPI, getMckessonShippingLocationsLoading, getMckessonWorkflowItemsAPI, putMckessonWorkflowItemAPI } = useMckesson();
  const [orderList, setOrderList] = useState([]);
  const [currentOrder, setCurrentOrder] = useState<any>();
  const [currentOrderItem, setCurrentOrderItem] = useState<any>();
  const [selectedOrder, setSelectedOrder] = useState<any>(null);
  const [selectedOrderItem, setSelectedOrderItem] = useState<any>(null);
  const [orderDetails, setOrderDetails] = useState<any[]>([]);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportKey, setReportKey] = useState(0);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalCounts, setApprovalCounts] = useState<{ total: number; acted: number; allApproved: boolean } | null>(null);
  const currentUserId = useAppSelector(selectCurrentUserId);
  const [vendorOptions, setVendorOptions] = useState<DropDownValues[]>([]);
  const [shipToOptions, setShipToOptions] = useState<DropDownValues[]>([]);
  const [selectedShipTo, setSelectedShipTo] = useState<string>("");
  const [isMckessonSelected, setIsMckessonSelected] = useState(false);
  const [shipToError, setShipToError] = useState("");
  const DynamicInitialValues = {
    orderId: "",
    orderStatus: "",
    startDate: moment()
      .subtract(2, "month")
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
  };
  const [formInitialValues, setFormInitialValues] =
    useState(DynamicInitialValues);

  const getInvOrdList = () => {
    InvOrderListAPI(selectedVender ? { venderId: selectedVender } : {}).then(
      (res: any) => setInvOrdList(res)
    );
  };

  const itemSelectHandler = (checked: boolean, item: any) => {
    if (checked) {
      setSelectedInvOrd([...selectedInvOrd, item]);
    } else {
      setSelectedInvOrd(selectedInvOrd.filter((x: any) => x.id !== item.id));
    }
  };

  const { handleChange, values, handleSubmit, resetForm } = useFormik({
    initialValues: formInitialValues,
    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      try {
        getPurchaseOrderAPI(values).then((res) => {
          setOrderList(res);
          if (res?.length > 0) {
            const firstOrder = res[0];
            setSelectedOrder(firstOrder);
            setSelectedOrderItem(null);
            InvOrderByIdAPI({ id: firstOrder.id }).then((orderRes: any) => {
              if (orderRes) {
                setOrderDetails(orderRes);
              }
            });
          } else {
            setSelectedOrder(null);
            setSelectedOrderItem(null);
            setOrderDetails([]);
          }
        });
      } catch (err) { }
      setSubmitting(false);
    },
    enableReinitialize: true,
  });

  const handleCreateInvOrd = async () => {

    if (!isCreatePermitted) {
      toast.error("You don't have permission to create inventory order");
      return;
    }

    const hasMckessonItems = isMckessonSelected || selectedInvOrd.some((item: any) => item.defaultvendorname?.toLowerCase() === "mckesson");
    if (hasMckessonItems && !selectedShipTo) {
      setShipToError("Ship To is required");
      return;
    }
    setShipToError("");

    await purchaseOrderCreateAPI({
      orderDate: moment().format(),
      orderStatusId: selectedInvOrd[0].orderstatusid,
      vendorId: selectedInvOrd[0].vendorid,
      refNo: "",
      createdBy: currentUserId,
      isActive: true,
      shippingLocationId: selectedShipTo || null,
    }).then(async (res) => {
      const payload = selectedInvOrd.map((x: any) => {
        let data = {
          purchaseOrderId: res.id,
          orderingProductId: x.orderingProductId,
          locationCode: x.locationId,
          isActive: true,
          updatedBy: currentUserId,
          orderQty: x.orderqty,
          orderDate: x.orderdate,
          orderStatusId: x.orderstatusid,
          vendorId: x.vendorid,
          refNo: res.refNo || "",
          createdBy: currentUserId,
          comments: "",
          shippingLocationId: selectedShipTo || null,
        };
        return {
          ...data,
        };
      });
      await InvOrderCreateAPI(payload).then((res) => {
        getInvOrdList();
        handleSubmit();
      });
    });
  };

  const selectAllHandler = (checked: boolean) => {
    if (checked) {
      setSelectedInvOrd([...invOrdList]);
    } else {
      setSelectedInvOrd([]);
    }
  };
  //DELETE INVENTORY ORDER
  const toggleModal = () => {
    handleSubmit();
    toggleClass();
    setShowModal(!showModal);
  };

  const deleteInventoryOrder = async () => {
    await deleteInventoryPurchaseOrderAPI({ id: currentOrder.id }).then(
      (res: any) => {
        if (res) {
          toggleModal();
        }
      }
    );
  };
  const handleOrderComplete = async (id: string) => {
    await completeInventoryOrderItemAPI({ id: id }).then((res: any) => {
      if (res) {
        handleSubmit();
      }
    });
  };

  // Order detail functions
  const handleOrderClick = (order: any) => {
    setSelectedOrder(order);
    setSelectedOrderItem(null);
    InvOrderByIdAPI({ id: order.id }).then((res: any) => {
      if (res) {
        setOrderDetails(res);
      }
    });
  };

  const toggleItemDeleteModal = () => {
    toggleClass();
    setShowItemDeleteModal(!showItemDeleteModal);
  };

  const deleteInventoryOrderItem = async () => {
    await deleteInventoryOrderAPI({ id: currentOrderItem.id }).then((res: any) => {
      if (res) {
        toggleItemDeleteModal();
        if (selectedOrder) {
          handleOrderClick(selectedOrder);
        }
      }
    });
  };

  const handleInventoryOrderItemComplete = async (id: string) => {
    await completeInventoryOrderAPI({ id: id }).then((res: any) => {
      if (res) {
        if (selectedOrder) {
          handleOrderClick(selectedOrder);
        }
      }
    });
  };

  const handleExportOrderItem = async () => {
    if (!selectedOrder) return;
    const response = await getOrderItemExportAPI({ orderId: selectedOrder.id });
    const url = URL.createObjectURL(response);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Order_Items_List_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  };

  const onShowReportModal = () => {
    setShowReportModal(true);
    setReportKey((prevKey) => prevKey + 1);
  };

  const onCloseReportModal = () => {
    setShowReportModal(false);
  };

  const toggleApprovalModal = () => {
    toggleClass();
    setShowApprovalModal(!showApprovalModal);
  };

  const fetchApprovalCounts = (orderId: string) => {
    getMckessonWorkflowItemsAPI({ key: orderId }).then((res: any) => {
      if (res) {
        const total = res.length;
        const acted = res.filter((item: any) => item.isApproved === true || item.isApproved === false).length;
        const allApproved = total > 0 && res.every((item: any) => item.isApproved === true);
        setApprovalCounts({ total, acted, allApproved });
      }
    }).catch(() => {
      setApprovalCounts(null);
    });
  };

  const handleTransmitOrder = async () => {
    if (!selectedOrder?.id) return;
    try {
      await transmitPurchaseOrderAPI({ id: selectedOrder.id });
      handleSubmit();
    } catch (err) {
      // error handled in hook
    }
  };

  const handleReopenApprovals = async () => {
    if (!selectedOrder?.id) return;
    try {
      const res = await getMckessonWorkflowItemsAPI({ key: selectedOrder.id });
      if (res) {
        for (const item of res) {
          const updatedItem = {
            approvalWorkflowId: item.approvalWorkflowId,
            key: item.key,
            approverUserId: item.approverUserId,
            isApproved: null,
            timestamp: null,
            notes: "",
            id: item.id,
            isActive: item.isActive,
            createdOnUtc: item.createdOnUtc,
            updatedOnUtc: item.updatedOnUtc,
            createdBy: item.createdBy,
            updatedBy: item.updatedBy,
          };
          await putMckessonWorkflowItemAPI(updatedItem);
        }
        toast.success("Approvals have been reopened.");
        fetchApprovalCounts(selectedOrder.id);
      }
    } catch (err) {
      // error handled in hook
    }
  };

  useEffect(() => {
    if (selectedOrder?.id) {
      fetchApprovalCounts(selectedOrder.id);
    } else {
      setApprovalCounts(null);
    }
  }, [selectedOrder?.id]);

  const orderNoOptions = useMemo(() => {
    return [
      { value: "All", label: "All" },
      ...orderList.map((order: any) => ({
        value: order?.refNo,
        label: order?.refNo,
      })),
    ];
  }, [orderList]);

  useEffect(() => {
    orderStatusMasterAPI().then((res) => {
      setOrderStatusOptions([
        {
          value: "",
          label: "All",
        },
        ...res?.map((option: any) => {
          return {
            value: option.id,
            label: option.description || "",
          };
        }),
      ]);
      const activeOption = res?.find(
        (option: any) => option.description?.toLowerCase() === "active"
      );
      if (activeOption) {
        handleChange("orderStatus")(activeOption.id);
      }
    });
    getVendorsAPI({ searchText: "", includeDeleted: false })
      .then((res: Vendor[]) => {
        setVendorOptions([
          {
            value: "",
            label: "All",
          },
          ...res?.map((option: Vendor) => {
            return {
              value: option.id,
              label: option.name || "NA",
            };
          }),
        ]);
      })
      .catch();
    handleSubmit();
  }, []);

  useEffect(() => {
    getInvOrdList();
    setSelectedInvOrd([]);
  }, [selectedVender]);

  useEffect(() => {
    const hasMckessonItems = selectedInvOrd.some((item: any) => item.defaultvendorname?.toLowerCase() === "mckesson");
    if (hasMckessonItems && !isMckessonSelected && shipToOptions.length === 0) {
      getMckessonShippingLocationsAPI().then((res: any) => {
        if (res) {
          setShipToOptions([
            { value: "", label: "Please Select" },
            ...res.map((loc: any) => ({
              value: loc.id,
              label: `${loc.shippingLocationId} - ${loc.name}`,
            })),
          ]);
        }
      });
    }
  }, [selectedInvOrd]);

  const isPermitted = useModulePermissions(PermissionModule.INVENTORY_ORDER);
  const isCreatePermitted = isPermitted(PermissionIdentifier.CREATE_INVENTORY_ORDER);
  const isViewPermitted = isPermitted(PermissionIdentifier.VIEW_INVENTORY_ORDER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_INVENTORY_ORDER);
  const isMarkCompletePermitted = isPermitted(PermissionIdentifier.MARK_AS_COMPLETE_INVENTORY_ORDER);
  const isExportPermitted = isPermitted(PermissionIdentifier.EXPORT_INVENTORY_ORDER);
  const isPrintPermitted = isPermitted(PermissionIdentifier.PRINT_INVENTORY_ORDER);
  const isAnyActionPermitted = isViewPermitted || isDeletePermitted || isMarkCompletePermitted;

  return (
    <div className="inventory-order-wrapper">
      {(InvOrderListLoading ||
        getPurchaseOrderLoading ||
        getVendorsLoading ||
        InvOrdersLoading ||
        invOrderCreateLoading ||
        invPurchaseOrderDeleteLoading ||
        invOrderItemMarkCompleteLoading ||
        orderStatusMasterLoading ||
        purchaseOrderCreateLoading ||
        InvOrderByIdLoading ||
        getOrderItemsExportLoading ||
        invOrderDeleteLoading ||
        invOrderMarkCompleteLoading ||
        getMckessonShippingLocationsLoading ||
        purchaseOrderTransmitLoading) && <Loading />}
      <div className="inventory-order-header">
        <h2>Inventory Order</h2>
      </div>
      <div className="inventory-order-detail-box">
        <Tabs
          defaultActiveKey="invtCreateOrder"
          id="create-order-tab"
          className="mb-3"
          unmountOnExit
        >
          <Tab eventKey="invtCreateOrder" title="Create Order">
            <div className="invt-create-order-content-wrapper">
              <div className="create-order-action-container">
                <div className="create-order-action-box">
                  <label className="form-label">Vendor</label>
                  <Select
                    classNamePrefix="react-select"
                    className="vendorselectbox react-select-container"
                    options={vendorOptions}
                    value={vendorOptions?.find(
                      (option: DropDownValues) =>
                        option.value === selectedVender
                    )}
                    onChange={(e: any) => {
                      setSelectedVender(e.value);
                      setShipToError("");
                      const isMckesson = e.label?.toLowerCase() === "mckesson";
                      setIsMckessonSelected(isMckesson);
                      if (isMckesson) {
                        getMckessonShippingLocationsAPI().then(
                          (res: any) => {
                            if (res) {
                              setShipToOptions([
                                { value: "", label: "Please Select" },
                                ...res.map((loc: any) => ({
                                  value: loc.id,
                                  label: `${loc.shippingLocationId} - ${loc.name}`,
                                })),
                              ]);
                            }
                          }
                        );
                      } else {
                        setShipToOptions([]);
                        setSelectedShipTo("");
                      }
                      getInvOrdList();
                    }}
                  />
                </div>
                {(isMckessonSelected || selectedInvOrd.some((item: any) => item.defaultvendorname?.toLowerCase() === "mckesson")) && (
                  <div className="create-order-action-box">
                    <label className="form-label">Ship To <span className="text-danger">*</span></label>
                    <Select
                      classNamePrefix="react-select"
                      className={`vendorselectbox react-select-container${shipToError ? " is-invalid" : ""}`}
                      options={shipToOptions}
                      placeholder="Please Select"
                      value={shipToOptions?.find(
                        (option: DropDownValues) =>
                          option.value === selectedShipTo
                      )}
                      onChange={(e: any) => {
                        setSelectedShipTo(e.value);
                        setShipToError("");
                      }}
                    />
                    {shipToError && (
                      <div className="text-danger" style={{ fontSize: "12px" }}>
                        {shipToError}
                      </div>
                    )}
                  </div>
                )}
                <div className="create-order-action-box">
                  <Button
                    variant="primary"
                    onClick={handleCreateInvOrd}
                    disabled={
                      selectedInvOrd.length === 0 ||
                      ((isMckessonSelected || selectedInvOrd.some((item: any) => item.defaultvendorname?.toLowerCase() === "mckesson")) && !selectedShipTo)
                    }
                  >
                    Create Order
                  </Button>
                </div>
                <div className="create-order-action-box clear-all-box">
                  <button
                    type="button"
                    className="clear-filter-btn"
                    onClick={() => {
                      setSelectedVender("");
                      setIsMckessonSelected(false);
                      setShipToOptions([]);
                      setSelectedShipTo("");
                      setShipToError("");
                      getInvOrdList();
                    }}
                  >
                    Clear All
                  </button>
                </div>
                <div className="create-order-action-box refresh-icon-box">
                  <button
                    type="button"
                    className="refresh-btn"
                    title="Refresh"
                    onClick={() => {
                      getInvOrdList();
                    }}
                  >
                    <ReactSVG className="svg-box" wrapper="span" src={refreshicon} />
                  </button>
                </div>
              </div>
              <div className="inventory-order-table-wrapper">
                <div className="listing-table-wrapper">
                  <Table responsive="md" hover={true}>
                    <thead>
                      <tr>
                        <th>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            onChange={(e) => selectAllHandler(e.target.checked)}
                            checked={
                              selectedInvOrd.length === invOrdList.length
                            }
                          />
                        </th>
                        <th>Product No</th>
                        <th>Description</th>
                        <th>Location</th>
                        <th>Reorder Level</th>
                        <th>Quantity On Hand</th>
                        <th>Order Quantity</th>
                        <th>Unit</th>
                        <th>Vendor Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {invOrdList?.map((item: any) => (
                        <tr key={item.id}>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={selectedInvOrd.includes(item)}
                              onChange={(e) =>
                                itemSelectHandler(e.target.checked, item)
                              }
                            />
                          </td>
                          <td>{item.productNo ?? "-"}</td>
                          <td>{item.productDescription ?? "-"}</td>
                          <td>{item.locationName ?? "-"}</td>
                          <td>{item.reorderLevel ?? "-"}</td>
                          <td
                            ref={(el) => {
                              if (el && item?.color) {
                                el.style.setProperty(
                                  "color",
                                  item?.color.toLowerCase(),
                                  "important"
                                );
                              }
                            }}
                          >
                            {item.qtyonhand ?? "-"}
                          </td>
                          <td>{item.orderqty ?? "-"}</td>
                          <td>{item.unitName ?? "-"}</td>
                          <td>{item.defaultvendorname ?? "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="invtorder" title="Orders">
            <div className="order-filter-wrapper">
              <div className="order-filter-item-wrapper">
                <div className="filter-item-box location-filter-item">
                  <label className="form-label">Status</label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={orderStatusOptions}
                    placeholder="Status"
                    id="orderStatus"
                    name="orderStatus"
                    value={orderStatusOptions?.find(
                      (option: DropDownValues) =>
                        option.value === values.orderStatus
                    )}
                    onChange={(option: any) => {
                      handleChange("orderStatus")(option.value);
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box type-filter-item">
                  <label className="form-label">Order</label>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    options={orderNoOptions}
                    id="orderId"
                    name="orderId"
                    value={orderStatusOptions?.find(
                      (option: DropDownValues) =>
                        option.value === values.orderId
                    )}
                    onChange={(option: any) => {
                      handleChange("orderId")(option.value);
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    locale="en-US"
                    format="MM/dd/yyyy"
                    openCalendarOnFocus={false}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    className="form-control"
                    clearIcon={null}
                    calendarIcon={<i className="bi bi-calendar"></i>}
                    showLeadingZeros={true}
                    maxDate={
                      values.endDate ? new Date(values.endDate) : new Date()
                    }
                    value={values.startDate}
                    onChange={(date: any) => {
                      handleChange({
                        target: {
                          name: "startDate",
                          value: moment(date)
                            .utc()
                            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        },
                      });
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    locale="en-US"
                    format="MM/dd/yyyy"
                    openCalendarOnFocus={false}
                    dayPlaceholder="dd"
                    monthPlaceholder="mm"
                    yearPlaceholder="yyyy"
                    className="form-control"
                    clearIcon={null}
                    calendarIcon={<i className="bi bi-calendar"></i>}
                    showLeadingZeros={true}
                    value={values.endDate}
                    maxDate={new Date()}
                    minDate={
                      values.startDate ? new Date(values.startDate) : new Date()
                    }
                    onChange={(date: any) => {
                      handleChange({
                        target: {
                          name: "endDate",
                          value: moment(date)
                            .utc()
                            .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                        },
                      });
                      handleSubmit();
                    }}
                  />
                </div>
                <div className="filter-item-box clear-all-box">
                  <button
                    type="button"
                    className="clear-filter-btn"
                    onClick={() => {
                      resetForm();
                      handleSubmit();
                    }}
                  >
                    Clear All
                  </button>
                </div>
                <div className="filter-item-box refresh-icon-box">
                  <button
                    type="button"
                    className="refresh-btn"
                    title="Refresh"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    <ReactSVG className="svg-box" wrapper="span" src={refreshicon} />
                  </button>
                </div>
              </div>
            </div>
            <div className="inventory-order-table-wrapper">
              <div className="listing-table-wrapper order-list-table">
                <Table responsive="md" hover={true}>
                  <thead>
                    <tr>
                      <th>Order No</th>
                      <th>Order Date</th>
                      <th>Status</th>
                      <th>Vendor Name</th>
                      <th>Ship To</th>
                      <th>Transmitted?</th>
                      <th>Approval Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderList.map((data: any) => (
                      <tr
                        key={data.id}
                        className={selectedOrder?.id === data.id ? "selected-row" : ""}
                        onClick={() => handleOrderClick(data)}
                        style={{ cursor: "pointer" }}
                      >
                        <td>{data.refNo}</td>
                        <td>
                          {data.orderDate
                            ? moment(data.orderDate).format("MM/DD/YYYY")
                            : "NA"}
                        </td>
                        <td>
                          <span
                            className={
                              "status-circle " +
                              (data?.orderStatusMaster?.description ===
                                "Completed" || "Active"
                                ? "active"
                                : "inactive")
                            }
                          >
                            {data?.orderStatusMaster?.description}
                          </span>
                        </td>
                        <td>{data?.vendorMaster?.name}</td>
                        <td>{data?.shippingLocation?.shippingLocationId ?? "-"}</td>
                        <td>{data?.isTransmitted ? "Yes" : "No"}</td>
                        <td>
                          <span
                            className={
                              "status-circle " +
                              (data?.approvalStatus === "Approved"
                                ? "active"
                                : data?.approvalStatus === "Rejected"
                                  ? "inactive"
                                  : "")
                            }
                          >
                            {data?.approvalStatus ?? "-"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
            {/* Order Action Buttons */}
            {selectedOrder && (
              <div className="order-action-bar">
                <div className="order-record-count">
                  {orderList.length} record(s)
                </div>
                <div className="order-action-buttons">
                  {/* <Button
                    variant="outline-warning"
                    disabled={selectedOrder?.approvalStatus !== "Rejected"}
                    onClick={handleReopenApprovals}
                  >
                    Reopen
                  </Button> */}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={toggleApprovalModal}
                  >
                    Approvals{approvalCounts ? ` (${approvalCounts.acted}/${approvalCounts.total})` : ""}
                  </Button>
                  {isDeletePermitted && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => {
                        setCurrentOrder(selectedOrder);
                        toggleModal();
                      }}
                    >
                      Delete Order
                    </Button>
                  )}
                  {isMarkCompletePermitted && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      disabled={!approvalCounts?.allApproved}
                      onClick={() => handleOrderComplete(selectedOrder.id)}
                    >
                      Mark Complete
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    disabled={selectedOrder?.isTransmitted !== false || !approvalCounts?.allApproved}
                    onClick={handleTransmitOrder}
                  >
                    Transmit Order
                  </Button>
                  {isPrintPermitted && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={onShowReportModal}
                    >
                      Print Order
                    </Button>
                  )}
                  {isExportPermitted && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleExportOrderItem}
                    >
                      Export Order
                    </Button>
                  )}
                </div>
              </div>
            )}

            {/* Order Items Section - shown when an order is selected */}
            {selectedOrder && (
              <div className="order-items-section">
                <div className="order-items-header">
                  <h4>Order Items</h4>
                </div>
                {/* <div className="order-detail-info">
                  <div className="order-detail-info-item">
                    <label>Order Date</label>
                    <p>
                      {selectedOrder.orderDate
                        ? moment(selectedOrder.orderDate).format("MM/DD/YYYY")
                        : "-"}
                    </p>
                  </div>
                  <div className="order-detail-info-item">
                    <label>Status</label>
                    <p>{selectedOrder?.orderStatusMaster?.description || "-"}</p>
                  </div>
                  <div className="order-detail-info-item">
                    <label>Vendor Name</label>
                    <p>{selectedOrder?.vendorMaster?.name || "-"}</p>
                  </div>
                </div> */}
                <div className="inventory-order-table-wrapper">
                  <div className="listing-table-wrapper order-items-table">
                    <Table responsive="md" hover={true}>
                      <thead>
                        <tr>
                          <th>Order No</th>
                          <th>Product No</th>
                          <th>Description</th>
                          <th>Location</th>
                          <th>Reorder Level</th>
                          <th>Qty on Hand</th>
                          <th>Order Qty</th>
                          <th>Unit</th>
                          <th>Order Qty (Purchase UOM)</th>
                          <th>Rate (per Purchase UOM)</th>
                          <th>Purchase UOM</th>
                          <th>Status</th>
                          <th>Vendor Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orderDetails?.map((data: any) => (
                          <tr
                            key={data.id}
                            className={selectedOrderItem?.id === data.id ? "selected-row" : ""}
                            onClick={() => setSelectedOrderItem(data)}
                            style={{ cursor: "pointer" }}
                          >
                            <td>{data?.refNo ?? "-"}</td>
                            <td>{data?.productNo ?? "-"}</td>
                            <td>{data?.productDescription ?? "-"}</td>
                            <td>{data?.locationName ?? "-"}</td>
                            <td>{data?.reorderLevel ?? "-"}</td>
                            <td
                              ref={(el) => {
                                if (el && data?.color) {
                                  el.style.setProperty(
                                    "color",
                                    data?.color.toLowerCase(),
                                    "important"
                                  );
                                }
                              }}
                            >
                              {data?.qtyOnHand ?? "-"}
                            </td>
                            <td>{data?.orderQty ?? "-"}</td>
                            <td>{data?.unitName ?? "-"}</td>
                            <td>{data?.orderQtyPurchaseUOM ?? "-"}</td>
                            <td>{data?.ratePerPurchaseUOM ?? "-"}</td>
                            <td>{data?.purchaseUOM ?? "-"}</td>
                            <td>
                              <span
                                className={
                                  "status-circle " +
                                  (data?.status === "Active"
                                    ? "active"
                                    : "inactive")
                                }
                              >
                                {data?.status}
                              </span>
                            </td>
                            <td>{data?.vendorName ?? "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
                {/* Order Items Action Buttons */}
                <div className="order-action-bar">
                  <div className="order-record-count">
                    {orderDetails.length} record(s)
                  </div>
                  <div className="order-action-buttons">
                    {isDeletePermitted && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        disabled={!selectedOrderItem}
                        onClick={() => {
                          if (selectedOrderItem) {
                            setCurrentOrderItem(selectedOrderItem);
                            toggleItemDeleteModal();
                          }
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    {/* <Button
                      variant="outline-secondary"
                      disabled={!selectedOrderItem}
                    >
                      Edit
                    </Button> */}
                    {isMarkCompletePermitted && (
                      <Button
                        variant="outline-primary"
                        size="sm"
                        disabled={!selectedOrderItem}
                        onClick={() => {
                          if (selectedOrderItem) {
                            handleInventoryOrderItemComplete(selectedOrderItem.id);
                          }
                        }}
                      >
                        Mark Complete
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Tab>
        </Tabs>
      </div>
      {/* Delete Inventory Order */}
      <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteInventoryOrder}
        modelName={`Inventory Order`}
        recordName={currentOrder?.refNo || ""}
        isDeletePermitted={isDeletePermitted}
      />
      {/* Delete Inventory Order Item */}
      <DeleteConfModel
        showModal={showItemDeleteModal}
        toggleModal={toggleItemDeleteModal}
        deleteAction={deleteInventoryOrderItem}
        modelName={`Inventory Order Item`}
        recordName={currentOrderItem?.refNo || ""}
        isDeletePermitted={isDeletePermitted}
      />
      {/* Order Report Modal */}
      <Modal
        size="xl"
        id="trans-report-modal"
        className="purchase-order-modal-main"
        show={showReportModal}
        onHide={onCloseReportModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Purchase Order</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="trans-report-content-wrapper">
            <div className="trans-report-table-wrapper">
              {reportKey > 0 && selectedOrder && (
                <TelerikReporting
                  key={reportKey}
                  params={{
                    orderId: selectedOrder.id,
                  }}
                  reportName="OrderItemsReport.trdp"
                  reportEndPoint="inventoryorder/orderitems/get"
                />
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Approval Items */}
      <ApprovalItems
        showApprovalModal={showApprovalModal}
        toggleApprovalModal={toggleApprovalModal}
        orderId={selectedOrder?.id ?? ""}
        orderNo={selectedOrder?.refNo ?? ""}
        onApprovalUpdate={() => selectedOrder?.id && fetchApprovalCounts(selectedOrder.id)}
      />
    </div>
  );
};

export default InventoryOrderList;
